import { Component, OnInit, OnChanges, EventEmitter, Input } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CiacService } from 'src/app/services/http/ciac.service';
import { ModalMsgService } from 'src/app/services/modal-msg.service';

@Component({
  selector: 'app-dcs',
  templateUrl: './dcs.component.html',
  styleUrls: ['./dcs.component.scss']
})
export class DcsComponent implements OnInit {
  
  visibilidade = [{
    nome: 'Privado',
    checked: false
  }];

  form = new FormGroup({
    nome: new FormControl('', [Validators.required]),
    descricao: new FormControl(''),
    caminho: new FormControl(''),
    tipo: new FormControl('', [Validators.required]),
    dadosConsultaSaidaPai: new FormControl('')
  });

  id;
  idConsulta: any;
  idTipoConsulta: any;
  idSaida: any;
  nomeTipoConsulta: any;
  checkedForm: any = false;
  listaTipoCampo = [];
  loading = new EventEmitter();
  dadosAtualizacao = [];
  listaDCSPai = [];

  total:number = 0;
  tableLoading = false;

  constructor(private activatedRoute: ActivatedRoute, private ciacService: CiacService, private router: Router, private modal: ModalMsgService) { }

  ngOnInit() {
    this.id = this.activatedRoute.snapshot.params.id || null;
    if(this.id && this.id != null && this.id != '') {
      this.getInfoDados(this.id);
    }

    this.ciacService.getTiposCampo().then(c => { this.listaTipoCampo = this.listaTipoCampo.concat(c) });
    this.ciacService.getListaTipoDadosSaida(this.id).then(c => { this.listaDCSPai = this.listaDCSPai.concat(c.lista) });

    this.ciacService.dadosFormulario.subscribe(c => {
      if(c) {
        if(c.id) {
          this.dadosAtualizacao.push({ id: c.id });
        }
        this.form.controls.nome.patchValue(c.nome);
        this.form.controls.descricao.patchValue(c.descricao);
        this.form.controls.caminho.patchValue(c.caminho);
        this.form.controls.tipo.patchValue(c.idTipoConsulta);
        this.form.controls.dadosConsultaSaidaPai.patchValue(c.idDadosConsultaSaidaPai);
        this.checkedForm = c.visibilidade;
      }
    });
  }

  getInfoDados(id) {
    this.ciacService.getDadosSaida(id).then(c => {
      this.idConsulta = c['id'] ? c['id'] : '0';
      this.idTipoConsulta = c['idTipoConsulta'];
      this.nomeTipoConsulta = c['nome'] ? c['nome'] : 'INEXISTENTE';
    });
  }

  checkedVisibilidade(event) {
    this.checkedForm = event;
  }

  submitForm() {
    let params;
    if(this.dadosAtualizacao.length > 0) {
      params = {
        id: this.dadosAtualizacao[0].id,
        idConsulta: parseInt(this.id),
        idTipo: parseInt(this.form.controls.tipo.value),
        nome: this.form.controls.nome.value,
        descricao: this.form.controls.descricao.value,
        visibilidade: this.checkedForm,
        caminho: this.form.controls.caminho.value,
        idDadosConsultaSaidaPai: parseInt(this.form.controls.dadosConsultaSaidaPai.value)
      };
    }else {
      params = {
        idConsulta: parseInt(this.id),
        idTipo: parseInt(this.form.controls.tipo.value),
        nome: this.form.controls.nome.value,
        descricao: this.form.controls.descricao.value,
        visibilidade: this.checkedForm,
        caminho: this.form.controls.caminho.value,
        idDadosConsultaSaidaPai: parseInt(this.form.controls.dadosConsultaSaidaPai.value)
      };
    }

    this.ciacService.addDadosSaida(params).then(c => {
      if(c.success) {
        this.router.navigateByUrl('/listar', {skipLocationChange: true}).then( () =>
          this.router.navigate(['ciac', 'consultas', 'dados-consulta-saida', params.idConsulta])
        );
        this.checkedForm = false;
        this.form.reset();
        this.loading.emit(true);
      }else if(c.message === "Chave (Consulta, caminho, nome e tipo) já cadastrada!") {
        this.modal.openDialog(
          'Informação já cadastrada!',
          'Por favor, verifique os campos e tente novamente.',
          'danger'
        );
        return;
      }else {
        this.modal.openDialog(
          'Erro ao cadastrar informações',
          'Por favor, tente novamente.',
          'danger'
        );
        return;
      }
    });
  }

  submitEdit() {

  }
}
